'use client';

import { c as _c } from "react/compiler-runtime";
import Snackbar from '@eversports/klimt-primitives/Snackbar';
import { useSnackbarStore } from './snackbar-store';
export function SnackbarProvider() {
  const $ = _c(5);
  const snackbar = useSnackbarStore(_temp);
  const closeSnackbar = useSnackbarStore(_temp2);
  let t0;
  if ($[0] !== closeSnackbar || $[1] !== snackbar) {
    t0 = snackbar && <Snackbar variant={snackbar.variant} message={snackbar.message} timeout={snackbar.options?.timeout} dataTestId={snackbar.options?.dataTestId} onClose={closeSnackbar} />;
    $[0] = closeSnackbar;
    $[1] = snackbar;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t0) {
    t1 = <>{t0}</>;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
function _temp2(state_0) {
  return state_0.closeSnackbar;
}
function _temp(state) {
  return state.snackbar;
}